/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../colors";
import { IconWrapperRounded } from "../../IconWrapperRounded";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  label?: string;
  innerRef?: any;
  text?: React.ReactNode;
  customIcon?: React.ReactNode;
  wrapperWidth?: string;
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  align-items: center;
  width: 100%;
  cursor: pointer;
  margin-bottom: 0px !important;
  color: ${colors.textPrimary};
  &:hover {
    background-color: ${colors.whiteHover};
  }
  > .checkmarkWrapper {
    opacity: 0;
  }
  > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &:has(input:disabled) {
    background-color: ${colors.whiteHover};
    color: ${colors.textSecondary};
    &:hover {
      background-color: ${colors.transparent};
    }
  }
  &:has(input:checked) {
    background-color: ${colors.whiteHover};
  }
  > input:checked ~ .checkmarkWrapper {
    opacity: 1;
  }
`;

export const CheckListField = ({
  label,
  value,
  innerRef,
  disabled,
  text,
  wrapperWidth,
  customIcon,
  ...rest
}: Props) => {
  return (
    <label css={wrapperStyle}>
      <input
        disabled={disabled}
        value={value}
        type="checkbox"
        ref={innerRef}
        {...rest}
      />
      <IconWrapperRounded
        className="checkmarkWrapper"
        backgroundColor={colors.transparent}
      >
        {customIcon ? (
          customIcon
        ) : (
          <FontAwesomeIcon className="checkmark" icon={solid("check")} />
        )}
      </IconWrapperRounded>
      <StyledText className="bodyTextRegular mb-0">{label}</StyledText>
    </label>
  );
};
